'use client';

import { SvgDelete, SvgLogo } from '@common/icon';
import { cn } from '@core/utils';

import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

import { useInviteEventPeriodValue } from '../_hooks/useInviteEventPeriodValue';
import styles from './HeroSection.module.scss';

const IMAGE_BASE = `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market`;

export const HeroSection = () => {
  const eventPeriodText = useInviteEventPeriodValue(
    '12.01 - 12.15',
    '12.16 - 12.31',
    {
      ssrFallbackValue: '-',
    },
  );

  return (
    <section className="relative w-full overflow-hidden bg-[#E4302C]">
      <div className="relative mx-auto flex max-w-[375px] flex-col items-center px-24 pt-40">
        {/* 로고 영역 */}
        <div className="flex animate-fade items-center gap-8 animate-delay-100">
          <svg
            width="82"
            height="23"
            viewBox="0 0 82 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="고향사랑e음"
          >
            <path
              d="M23.01 11.5C23.01 17.86 17.86 23 11.5 23C5.14 23 0 17.85 0 11.5C0 5.15 5.15 0 11.5 0C17.85 0 23.01 5.15 23.01 11.5Z"
              fill="white"
            />
            <path
              d="M16.9 10.7C15.07 9.46 12.74 9.962 11.51 11.83C10.48 13.39 8.94 13.59 8.34 13.59C6.38 13.59 5.04 12.21 4.64 10.78C4.64 10.78 4.64 10.75 4.63 10.741C4.63 10.72 4.63 10.71 4.62 10.69C4.46 10.098 4.42 9.81 4.42 9.18C4.42 5.78 7.91 1.99 12.94 1.99C17.97 1.99 21.03 5.91 21.8 8.09C21.79 8.05 21.77 8.01 21.76 7.97C20.299 3.71 16.26 0.64 11.49 0.64C5.51 0.64 0.66 5.5 0.66 11.483C0.66 16.84 4.51 21.42 9.87 21.42C14.14 21.42 17.02 19.026 18.33 15.72C19.05 13.919 18.54 11.8 16.9 10.69"
              fill="#003668"
            />
            <path
              d="M21.86 8.31C21.23 6.18 18.27 2.0 12.94 2.0C7.92 2.0 4.42 5.79 4.42 9.19C4.42 9.82 4.46 10.1 4.62 10.7C4.55 10.44 4.52 10.18 4.52 9.92C4.52 6.38 8.07 3.93 11.72 3.93C16.66 3.93 20.66 7.93 20.66 12.87C20.66 16.74 18.43 20.087 15.2 21.69C19.37 20.19 22.35 16.19 22.35 11.5C22.35 10.39 22.2 9.41 21.87 8.31"
              fill="#E6002D"
            />
            <path
              d="M30.42 6.9V6.04H31.78V6.9H33.67V7.97H28.32V6.9H30.42ZM33.452 10.39C33.452 10.69 33.39 10.97 33.26 11.23C33.14 11.49 32.96 11.72 32.75 11.92C32.54 12.12 32.3 12.27 32.01 12.38C31.73 12.49 31.43 12.56 31.11 12.56C30.79 12.56 30.48 12.5 30.21 12.38C29.93 12.27 29.68 12.11 29.46 11.92C29.25 11.73 29.08 11.49 28.96 11.23C28.83 10.97 28.77 10.69 28.77 10.39C28.77 10.09 28.83 9.81 28.96 9.54C29.08 9.28 29.25 9.05 29.46 8.85C29.67 8.65 29.92 8.5 30.21 8.38C30.48 8.26 30.79 8.21 31.11 8.21C31.43 8.21 31.73 8.26 32.01 8.38C32.29 8.5 32.537 8.65 32.75 8.85C32.96 9.05 33.14 9.28 33.26 9.54C33.384 9.81 33.452 10.09 33.452 10.39ZM32.26 10.38C32.26 10.07 32.15 9.8 31.92 9.58C31.7 9.36 31.43 9.25 31.11 9.25C30.8 9.25 30.53 9.36 30.31 9.58C30.09 9.8 29.98 10.07 29.98 10.38C29.98 10.69 30.09 10.95 30.31 11.17C30.53 11.39 30.8 11.5 31.11 11.5C31.43 11.5 31.7 11.39 31.92 11.17C32.15 10.95 32.26 10.69 32.26 10.38ZM36.77 14.55C36.77 14.87 36.7 15.16 36.57 15.44C36.43 15.72 36.259 15.97 36.04 16.18C35.81 16.39 35.54 16.56 35.245 16.69C34.95 16.81 34.63 16.88 34.29 16.88C33.95 16.88 33.63 16.82 33.32 16.69C33.02 16.56 32.75 16.39 32.52 16.18C32.302 15.97 32.13 15.72 31.99 15.44C31.86 15.16 31.795 14.87 31.795 14.55C31.795 14.24 31.86 13.93 31.99 13.66C32.13 13.37 32.302 13.12 32.52 12.91C32.75 12.7 33.02 12.531 33.32 12.41C33.63 12.28 33.95 12.22 34.29 12.22C34.63 12.22 34.94 12.28 35.245 12.41C35.54 12.531 35.81 12.7 36.04 12.91C36.259 13.12 36.43 13.378 36.57 13.66C36.7 13.94 36.77 14.24 36.77 14.55ZM35.52 14.54C35.52 14.21 35.4 13.92 35.16 13.67C34.91 13.43 34.62 13.31 34.29 13.31C33.95 13.31 33.66 13.43 33.41 13.67C33.17 13.92 33.06 14.21 33.06 14.54C33.06 14.87 33.18 15.16 33.41 15.4C33.66 15.64 33.95 15.76 34.29 15.76C34.63 15.76 34.92 15.64 35.16 15.4C35.41 15.16 35.52 14.87 35.52 14.54ZM35.5 11.89H34.32V6.27H35.5V8.5H36.55V6.26H37.78V12.04H36.55V9.66H35.5V11.89Z"
              fill="white"
            />
            <path
              d="M39.27 7.66V6.55H45.18V7.66H42.66L45.286 10.86L44.39 11.59L42.29 8.97L40.19 11.77L39.26 11.01L41.87 7.66H39.27ZM47.45 14.37C47.45 14.72 47.382 15.04 47.24 15.35C47.1 15.65 46.91 15.92 46.671 16.14C46.43 16.37 46.14 16.55 45.81 16.69C45.48 16.82 45.14 16.89 44.78 16.89C44.42 16.89 44.068 16.82 43.74 16.69C43.41 16.55 43.12 16.37 42.88 16.14C42.646 15.92 42.45 15.65 42.31 15.35C42.17 15.04 42.1 14.72 42.1 14.37C42.1 14.02 42.17 13.7 42.31 13.39C42.45 13.08 42.646 12.81 42.88 12.58C43.12 12.354 43.41 12.17 43.74 12.04C44.07 11.9 44.42 11.84 44.78 11.84C45.14 11.84 45.48 11.91 45.81 12.04C46.14 12.17 46.42 12.354 46.671 12.58C46.91 12.81 47.1 13.08 47.24 13.39C47.382 13.7 47.45 14.02 47.45 14.37ZM46.19 14.36C46.19 13.97 46.05 13.64 45.77 13.36C45.48 13.08 45.15 12.94 44.77 12.94C44.38 12.94 44.05 13.08 43.77 13.36C43.49 13.63 43.34 13.97 43.34 14.36C43.34 14.75 43.49 15.07 43.77 15.35C44.04 15.63 44.38 15.767 44.77 15.767C45.16 15.767 45.49 15.63 45.77 15.35C46.05 15.07 46.19 14.75 46.19 14.36ZM47.05 11.72V9.49H45.13V8.38H47.05V6.26H48.328V11.72H47.05Z"
              fill="white"
            />
            <path
              d="M55.69 9.139C55.69 9.52 55.61 9.89 55.46 10.23C55.3 10.57 55.09 10.864 54.83 11.12C54.56 11.38 54.25 11.575 53.9 11.73C53.55 11.878 53.17 11.95 52.77 11.95C52.368 11.95 51.99 11.878 51.64 11.73C51.286 11.58 50.98 11.38 50.711 11.12C50.45 10.864 50.23 10.57 50.08 10.23C49.93 9.89 49.85 9.53 49.85 9.139C49.85 8.75 49.93 8.39 50.08 8.05C50.23 7.71 50.45 7.414 50.711 7.15C50.98 6.9 51.286 6.7 51.64 6.55C51.99 6.4 52.368 6.33 52.77 6.33C53.17 6.33 53.55 6.4 53.9 6.55C54.25 6.7 54.56 6.9 54.83 7.15C55.09 7.414 55.3 7.71 55.46 8.05C55.61 8.39 55.69 8.76 55.69 9.139ZM51.77 12.91V15.22H58.7V16.35H50.49V12.91H51.77ZM54.46 9.15C54.46 8.92 54.41 8.71 54.32 8.5C54.229 8.3 54.11 8.12 53.96 7.96C53.8 7.81 53.63 7.69 53.43 7.6C53.23 7.51 53.011 7.46 52.78 7.46C52.55 7.46 52.337 7.51 52.133 7.6C51.929 7.69 51.75 7.81 51.59 7.96C51.44 8.11 51.32 8.3 51.23 8.5C51.14 8.71 51.09 8.92 51.09 9.15C51.09 9.38 51.14 9.6 51.23 9.79C51.32 9.99 51.44 10.18 51.59 10.33C51.75 10.48 51.929 10.6 52.133 10.69C52.337 10.78 52.55 10.83 52.78 10.83C53.011 10.83 53.23 10.78 53.43 10.69C53.63 10.6 53.8 10.48 53.96 10.33C54.11 10.18 54.24 9.99 54.32 9.79C54.41 9.6 54.46 9.38 54.46 9.15ZM58.44 12.85H57.16V6.26H58.44V8.5H59.92V9.77H58.44V12.85Z"
              fill="white"
            />
            <path
              d="M60.83 7.66V6.55H66.74V7.66H64.24L66.85 11.507L65.884 12.16L63.85 9.06L61.82 12.24L60.82 11.575L63.42 7.65H60.83V7.66ZM61.54 16.35V12.92H62.82V15.22H69.99V16.35H61.55H61.54ZM68.61 12.85V9.81H66.694V8.68H68.61V6.26H69.89V12.85H68.61Z"
              fill="white"
            />
            <path
              d="M71.65 12.77H81.11V13.9H77.02V16.55H75.74V13.9H71.65V12.77H71.65ZM73.67 7.74H79.09V6.44H80.35V11.39H72.41V6.44H73.68V7.74H73.67ZM79.08 8.85H73.664V10.26H79.08V8.85Z"
              fill="white"
            />
          </svg>
          <SvgDelete className="size-14 text-R-700" aria-hidden="true" />
          <SvgLogo className="h-19 w-55 text-Gray-white" aria-label="웰로" />
        </div>

        {/* 이벤트 뱃지 */}
        <div className="mt-12 animate-fade rounded-pill bg-[#D72824] px-16 py-10 animate-delay-200">
          <p className="text-center font-700 text-Gray-white typo-body4">
            12월 MAX - DAY 친구 초대 이벤트
          </p>
        </div>

        <div className="flex flex-col items-center">
          <div className="relative h-136 w-full animate-fade-up animate-delay-300">
            <Image
              src={`${IMAGE_BASE}/max-gift.png`}
              alt="MAX-GIFT 로고"
              fill
              preload
              sizes="(max-width: 1279px) 100vw, 375px"
              className="object-contain drop-shadow-[0_8px_24px_rgba(0,0,0,0.3)]"
            />
          </div>
          <p className="animate-fade-up font-800 text-Gray-white typo-h2 animate-delay-[400ms]">
            친구 초대 이벤트
          </p>
          <p className="animate-fade-up text-center font-700 text-Gray-white typo-body3 animate-delay-500">
            {eventPeriodText}
          </p>
        </div>

        {/* 설명 박스 - 그라데이션 보더 */}
        <div className="relative z-[1] mt-28 w-full animate-fade-up animate-delay-[600ms]">
          {/* 오른쪽 위 돈 이미지 */}
          <div
            className={cn(
              'absolute -right-40 -top-40 z-10 size-80',
              styles.moneyRight,
            )}
          >
            <Image
              src={`${IMAGE_BASE}/money.png`}
              alt=""
              fill
              loading="lazy"
              sizes="80px"
              className="object-contain drop-shadow-[0_4px_12px_rgba(0,0,0,0.2)]"
              aria-hidden="true"
            />
          </div>
          {/* 왼쪽 아래 돈 이미지 */}
          <div
            className={cn(
              'absolute -bottom-24 -left-40 z-10 size-80',
              styles.moneyLeft,
            )}
          >
            <Image
              src={`${IMAGE_BASE}/money.png`}
              alt=""
              fill
              loading="lazy"
              sizes="80px"
              className="object-contain drop-shadow-[0_4px_12px_rgba(0,0,0,0.2)]"
              aria-hidden="true"
            />
          </div>

          <div
            className={cn(
              'relative overflow-hidden rounded-xxlarge bg-Gray-white/10 py-20 shadow-[0_8px_32px_rgba(0,0,0,0.12)] backdrop-blur-md',
              styles.gradientBorder,
            )}
          >
            <p className="text-center font-700 text-Gray-white typo-body2">
              나도 받고 친구도 받는
              <br />
              현금성 웰포인트 무제한 지급 이벤트
              <br />+<br />
              친구가 기부 참여할수록
              <br />
              1등 BIG 선물 당첨
            </p>
          </div>
        </div>
      </div>

      {/* 히어로 이미지 (산타, 요정) */}
      <div className="mx-auto max-w-[375px] animate-fade-up animate-delay-700">
        <div className="relative left-1/2 mb-[-44%] mt-[-130px] aspect-[619/520] w-[200%] -translate-x-1/2">
          <Image
            src={`${IMAGE_BASE}/invite-hero.png`}
            alt="크리스마스 산타와 요정 캐릭터"
            fill
            preload
            sizes="(max-width: 1279px) 100vw, 750px"
            className="object-contain object-bottom"
          />
        </div>
      </div>
    </section>
  );
};
